import React from "react";
import {
  Accordion,
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
} from "@/components/ui/accordion";
import { Reveal, Overline } from "./primitives";

const faqs = [
  {
    q: "What is FullContainer™?",
    a: "FullContainer™ is a DeMaxtore Workspace Product that lets importers purchase full container quantities directly from a single verified Turkish manufacturer, while managing the entire import operation — quotations, purchase orders, production, inspection, freight and shipment — inside one connected Workspace.",
  },
  {
    q: "Can I order directly from manufacturers?",
    a: "Yes. FullContainer™ is factory-direct by design. You buy an entire container straight from the manufacturer with no product markups and no intermediaries between you and the supplier.",
  },
  {
    q: "Can I manage existing suppliers?",
    a: "Absolutely. If you already know exactly what you need and which manufacturer you want to work with, you can run that supplier relationship and purchase order directly inside your FullContainer™ Workspace.",
  },
  {
    q: "Can I track production?",
    a: "Yes. Production status is a live module in your Workspace, showing manufacturing progress and estimated completion so you always know where your order stands.",
  },
  {
    q: "How does FreightIQ™ integrate?",
    a: "FreightIQ™ is connected end-to-end within the Workspace. You can compare ocean freight rates, book shipping and keep freight tied to the same purchase order and shipment record — no separate systems required.",
  },
  {
    q: "Can I monitor every shipment milestone?",
    a: "Yes. Live Shipment Tracking™ gives you full visibility across every milestone — from booking and origin to at-sea and arrival — with automated alerts as your shipment progresses.",
  },
];

export const FaqSection = () => {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="border-t border-slate-100 bg-white py-24 lg:py-32"
    >
      <div className="mx-auto grid max-w-6xl gap-12 px-6 lg:grid-cols-[0.9fr_1.4fr] lg:px-8">
        <Reveal>
          <Overline>FAQ</Overline>
          <h2 className="mt-4 font-display text-3xl font-bold tracking-tight text-ink md:text-4xl">
            Everything you need to know.
          </h2>
          <p className="mt-4 text-base text-slateink md:text-lg">
            Common questions about factory-direct full container procurement through the DeMaxtore
            Workspace.
          </p>
        </Reveal>

        <Reveal delay={0.1}>
          <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
            {faqs.map((f, i) => (
              <AccordionItem
                key={f.q}
                value={`item-${i}`}
                className="border-b border-slate-200"
                data-testid={`faq-item-${i}`}
              >
                <AccordionTrigger className="py-5 text-left text-base font-semibold text-ink hover:no-underline hover:text-demax">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="pb-5 text-sm leading-relaxed text-slateink">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
};
